import React, {
    useCallback,
    useEffect
} from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../redux/user/actions.user';
import asyncDispatch from '../../../services/mini/asyncDispatch';
import {
    confirmAlert
} from '../../../services/mini/alanConfirmAlert';
import ReactTooltip from 'react-tooltip';
import { getNeededStartsFromGitHubPlan } from '../../../services/mini/getNeededStartsFromGitHubPlan';
import { canSwitchToGitHubPromoPlan } from '../../../services/mini/canSwitchToGitHubPromoPlan';
import { checkForGitHubPromoPlan } from '../../../services/mini/checkForGitHubPromoPlan';
import SwitchToGitHubPromoPlanPopup from './SwitchToGitHubPromoPlanPopup/SwitchToGitHubPromoPlanPopup';
import { GitHubStars } from './GitHubStars';
import store from '../../../store';
import isLocalStorageAvailable from '../../../services/mini/isLocalStorageAvailable';
import SwitchGitHubPromoPlanPopupManager from '../../../services/SwitchGitHubPromoPlanPopupManager';

function GitHubPromoPlanControls({
    plan,
    numOfStars = 0,
    githubLogin,
    email,
    githubConnected,
    changePlan,
    getGithubPromoInfo
}) {
    const githubStars = getNeededStartsFromGitHubPlan(plan);
    const isGithubPromoPlan = checkForGitHubPromoPlan(plan);

    const showGithubConnectPopupCb = useCallback(() => {
        confirmAlert({
            customUI: ({
                onClose
            }) => {
                return (
                    <SwitchToGitHubPromoPlanPopup
                        store={store}
                        plan={plan}
                        changePlan={changePlan}
                        onClose={onClose}
                    />
                );
            }
        });
    }, [plan, changePlan]);

    useEffect(() => {
        if (SwitchGitHubPromoPlanPopupManager.shouldBeOpend(email)) {
            showGithubConnectPopupCb();
            SwitchGitHubPromoPlanPopupManager.markClosedForFuture(email);
        }
    }, [email, showGithubConnectPopupCb]);

    const changePlanCb = useCallback(async () => {
        if (isGithubPromoPlan) {
            const canSwitch = await canSwitchToGitHubPromoPlan(githubStars, getGithubPromoInfo);
            if (!canSwitch) {
                return;
            }
        }
        changePlan();
    }, [getGithubPromoInfo, changePlan, githubStars, isGithubPromoPlan]);



    return <React.Fragment>
        {githubConnected ?
            <React.Fragment>
                {githubStars <= numOfStars ?
                    <div className="plan-tile_btn-holder">
                        <div className={`plan-tile_btn`} onClick={changePlanCb}>
                            Change plan
                        </div>
                        <GitHubStars numOfStars={numOfStars} githubStars={githubStars} />
                    </div> :
                    <div className="plan-tile_btn-holder" onClick={showGithubConnectPopupCb}>
                        <div
                            className={`plan-tile_btn`}
                            data-tip="This plan requires a connection to your GitHub account, please connect it to proceed"
                            data-for="changePlanBtnTooltip"
                            data-place="top"
                            data-effect="solid"
                            data-class="tutor-dark-tooltip plan-tooltip">
                            Change plan
                        </div>
                        <GitHubStars numOfStars={numOfStars} githubStars={githubStars} />
                    </div>
                }
            </React.Fragment> :
            <div
                className="plan-tile_btn-holder"
                onClick={showGithubConnectPopupCb}>
                <div
                    className={`plan-tile_btn`}
                    data-tip="This plan requires a connection to your GitHub account, please connect it to proceed"
                    data-for="changePlanBtnTooltip"
                    data-place="top"
                    data-effect="solid"
                    data-class="tutor-dark-tooltip plan-tooltip">
                    Change plan
                </div>
                <ReactTooltip id="changePlanBtnTooltip" />
                <GitHubStars numOfStars={numOfStars} githubStars={githubStars} />
            </div>}
    </React.Fragment>;
}

function mapStateToProps({ user }, ownProps) {
    return {
        email: user.email
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getGithubPromoInfo: (param) => asyncDispatch(actions.getGithubPromoInfo, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GitHubPromoPlanControls);